<template>
  <div class="bg-white rounded" v-if="event.event_id==='ab87ca5a-a661-11ee-8bf2-1248ddbb6de9'">
    <div v-if="responseSubmitted" class="py-16 px-2 md:px-10 text-center">
      <p class="text-3xl mb-4">Thank you for registering for the Showman Showcase: Dinner & Demo!</p>
      <p v-if="response.attending === 'Yes!'" class="text-lg">We are excited that you will be joining us on Friday night at 6:30. We have your {{ response.dinner_reservation }} seats reserved for the dinner.</p>
      <p v-else-if="response.attending === 'No, but I would like to learn more.'" class="text-lg">We are sorry to hear you won't be able to join us in person. We will be in touch with additional information about Showman and answers to your quetions.</p>
      <p v-else class="text-lg">We are sorry to hear you won't be able to join us on Friday Night. Make sure to say hi at the show, and feel free to direct your questions to any staff members at the check-in table or apparel tables.</p>
    </div>
    <div v-else class="flex flex-col-reverse md:flex-row md:space-x-4 mt-4 md:p-4 ">
      <div class="w-full ">
        <p class="text-xl font-bold mb-2 text-center">RSVP by Wednesday, April 24th</p>
        <form-generator ref="registration_form" :form_schema="form" :country="event.location_details.country"></form-generator>
      </div>
      <div class="md:w-128 md:border-l ">
        <img src="https://res.cloudinary.com/showman/image/upload/v1713490291/Bounds_Sample_Banner_4.png" class="w-full rounded-t" alt="Special Area">
        <div class="md:pl-4 py-4 md:mb-0">
          <p class="text-center text-xl mb-1">April 26, 2024 ~ 6:30-8:00 PM</p>
          <p class="text-center mb-4 font-semibold">Litton Agri-Science Learning Center<br>Chillicothe, MO</p>
          <!--<p class="text-center text-base">Discover the power of Showman at our exclusive event: Showman Showcase: Dinner & Demo! Whether you're a seasoned livestock show organizer or new to the industry, this evening is your gateway to mastering show management with ease. Join us for a delightful dinner with fellow industry enthusiasts. Then, embark on a journey of discovery as we walk you through the ins and outs of Showman, the ultimate livestock show management platform. Perfect for beginners and seasoned pros alike, our interactive demo will introduce you to Showman's intuitive features, offering valuable insights and practical tips to streamline your event planning process. Don't miss this opportunity to learn, connect, and revolutionize your livestock shows with Showman. Reserve your spot today and unlock the tools for your next successful event!</p>
          -->
          <p class="font-semibold pb-1">Connect with the Showman Team</p>
          <p class="pb-3">Join us at the Showman Showcase: Dinner & Demo! Meet Josh, the founder and developer of Showman; share your feedback and ideas directly with him. Whether you're a seasoned user or new to the platform, we want to hear from you! Let's discuss all things Showman and the features you'd love to see added.</p>
          <p class="font-semibold pb-1">Live Demo: Explore the Show Manager Side</p>
          <p class="pb-3">Do you help at or run a livestock show? Or are you interested in starting one? Come for a live demo of the Show Manager side of Showman. See firsthand how easy it is to manage entries, break classes, record results, and more. Get a comprehensive overview of the tools that make Showman the ultimate solution for livestock show management.</p>
          <p class="font-semibold pb-1">Sneak Peek: Show + Sale = Solved</p>
          <p class="pb-3">Curious about what's next for Showman? Get an exclusive sneak peek of our recently developed Auction platform!</p>
          <p class="font-semibold pb-1">Dinner Provided & Raffle Prizes Available!</p>
          <p class="mt-8 text-lg text-center font-semibold">Questions - Please reach out to Ruth@showman.app</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormGenerator from '@/components/FormGenerator.vue'

export default {
  components: {
    FormGenerator
  },
  data () {
    return {
      response: {},
      responseSubmitted: false
    }
  },
  methods: {
    submitRegistration () {
      if (this.$refs.registration_form.validateForm()) {
        if (!this.validateEmail(this.response.email)) {
          return alert('Please double check your email Address to make sure it is in a valid format.')
        }
        let data = {
          event_id: this.$store.state.event.currentEvent.event_id,
          registration_data: this.response
        }
        this.$store.state.apiInstance.post('/data/specialRegistrationSubmission', data)
          .then(response => {
            this.responseSubmitted = true
            this.notie.alert({
              type: 'success',
              text: 'Registration submitted successfully'
            })
          })
      } else {
        this.notie.alert({
          type: 'error',
          text: 'Please fill out all required fields'
        })
      }
    },
    validateEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return email.match(re)
    }
  },
  computed: {
    event () {
      return this.$store.state.event.currentEvent
    },
    form () {
      return [
        {
          model: this.response,
          label: 'Showman Dinner & Demo Registration',
          fields: [
            {
              'type': 'input',
              'label': 'First Name',
              'model': 'first_name',
              'required': true,
              'inputType': 'text',
              'selectType': 'input:text'
            },
            {
              'type': 'input',
              'label': 'Last Name',
              'model': 'last_name',
              'required': true,
              'inputType': 'text',
              'selectType': 'input:text'
            },
            {
              'type': 'input',
              'label': 'Email',
              'model': 'email',
              'required': true,
              'inputType': 'text',
              'selectType': 'input:text'
            },
            {
              'type': 'input',
              'label': 'Phone Number',
              'model': 'phone_number',
              'required': true,
              'inputType': 'text',
              'selectType': 'input:text'
            },
            {
              'model': 'used_showman',
              'required': true,
              'label': 'Have you used Showman Before?',
              'selectType': 'select',
              'type': 'select',
              'options': [
                {
                  'label': 'Yes, as an exhibitor/parent',
                  'value': 'Yes, as an exhibitor/parent'
                },
                {
                  'label': 'Yes, as a show manager',
                  'value': 'Yes, as a show manager'
                },
                {
                  'label': 'Yes, both as an exhibitor and show manager',
                  'value': 'Yes, both as an exhibitor and show manager'
                },
                {
                  'label': 'No',
                  'value': 'No'
                }
              ]
            },
            {
              'model': 'experience',
              'required': false,
              'label': 'How many Years of experience do you have running livestock shows?',
              'selectType': 'input:number',
              'inputType': 'number',
              'type': 'input'
            },
            {
              'model': 'attending',
              'required': true,
              'label': 'Are you planning to attend on Friday night?',
              'selectType': 'select',
              'type': 'select',
              'options': [
                {
                  'label': 'Yes!',
                  'value': 'Yes!'
                },
                {
                  'label': 'No, but I would like to learn more.',
                  'value': 'No, but I would like to learn more.'
                },
                {
                  'label': 'No, but I will be at the show on Saturday',
                  'value': 'No, but I will be at the show on Saturday'
                },
                {
                  'label': 'No, but I will be at the show on Sunday',
                  'value': 'No, but I will be at the show on Sunday'
                }
              ],
              'hint': `If you can’t make it Friday, still complete this form if you’re interested in learning more. We will read every submission and will be in touch with answers to any questions you might have. Also, if you’ll be at the show Saturday or Sunday, we would love to connect and tell you more about Showman!`
            },
            {
              'model': 'dinner_reservation',
              'hint': 'We will be providing dinner for all attendees interested in joining us for the evening. Please let us know how many reservations you would like to make.',
              'required': true,
              'label': 'How many dinner reservations would you like to make?',
              'selectType': 'input:number',
              'inputType': 'number',
              'type': 'input'
            },
            {
              'model': 'questions',
              'required': false,
              'selectType': 'input:text',
              'inputType': 'text',
              'type': 'input',
              'label': 'What questions about Showman do you have? Or are there any features you would like to see added?'
            },
            {
              type: 'submit',
              buttonText: 'Submit RSVP',
              onSubmit: this.submitRegistration
            }
          ]
        }
      ]
    }
  }
}
</script>

<style>

</style>
